<template>
    <div class="w-full h-screen">
    <div class="flex items-stretch h-screen" v-if="loaded">
        <div class="sidebar text-left flex-shrink-0">
            <h1 class="title text-center border-b">Witness</h1>
            <div class="px-8">
                <!--          {{ game }}
        <h2 class="font-bold" @click="selectView('distrikt')">Game Event</h2>
        {{ ownId }}
        <p>connections</p>
        {{ connections }}
        <p>messages</p>
        {{ messages }}
        <div @click="pingParticipants('test')">send</div> -->
                <div class="select my-2 distrikt" :class="{ active: game.id == item.id }" @click="selectGame(item.id)" v-for="(item, index) in $store.games" :key="index">
                    <span>
                        {{ item.title }}
                    </span>
                    <ul class="collapse">
                        <li @click="selectView('event')" :class="{'active': select == 'event'}">Live Game</li>
                        <li @click="selectView('players')" :class="{'active': select ==  'players'}">Players</li>
                        <li @click="selectView('cards')" :class="{'active': select ==  'cards'}">Cards</li>
                        <li @click="selectView('history')" :class="{'active': select ==  'history'}">History</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="event w-full" v-if="select == 'players'">
       
             <div class="history" style="height: 100%; overflow: scroll">
                                <table class="tg" >
                                    <thead>
                                      <tr>
                                        <td>Name</td>
                                        <td>Email</td>
                                        <td>Chosen Policies</td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item, index) in game.players" :key="index">
                                        <td><b>{{ getPlayer(item).name }}</b></td>
                                        <td>{{ getPlayer(item).email }}</td>
                                        <td><span class="border rounded-full mr-2 p-2 px-4 inline-block mt-3" v-for="(item, index) in getPlayer(item).policies" :key="index">{{displayCard(item).name}}</span></td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>

        </div>
        <div class="event w-full" v-if="select == 'cards'">        
                <div class="history" style="height: 85%; overflow: scroll">
                                <table class="tg" >
                                    <thead>
                                      <tr>
                                        <td>Policy</td>
                                        <td>Regenerative</td>
                                        <td>Gameplay</td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item, index) in getCards(true)" :key="index" :class="{'regen': !displayCard(item).single_use}" :content="displayCard(item).gameplay" v-tippy="{followCursor : true}">
                                        <td><b>{{displayCard(item).name}}</b></td>
                                        <td>{{displayCard(item).single_use}}</td>
                                        <td>{{displayCard(item).gameplay}}</td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>

        </div>

        <div class="event w-full" v-if="select == 'history'">

         <div class="history" style="height: 85%; overflow: scroll">
                                <table class="tg" >
                                    <thead>
                                      <tr>
                                        <td>Round</td>
                                        <td>Policy</td>
                                        <td>Economy</td>
                                        <td>Infrastructure</td>
                                        <td>Public Opinion</td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item, index) in showHistory()" :key="index" :class="{'regen': !displayCard(item.policy).single_use}" :content="displayCard(item.policy).gameplay" v-tippy="{followCursor : true}">
                                        <td>{{parseInt(item.index) + 1}}</td>
                                        <td>{{displayCard(item.policy).name}}</td>
                                        <td>{{item.score.economy}}</td>
                                        <td>{{item.score.infrastructure}}</td>
                                        <td>{{item.score.opinion}}</td>
                                      </tr>
                                    </tbody>
                                </table>
                            </div>

        </div>

        <div class="event w-full" v-if="select == 'event' && getDistrikt().name">
            <div v-if="game.index == -1 && getDistrikt().name" class="round_introduction" :style="'background: url(' + getDistrikt().image + ')'">
                <div class="distrikt_intro">

                  <img class="distrikt" :src="getDistrikt().image" />

                  <h1>You are playing as <b>{{getDistrikt().name}}</b></h1>
                  <p>{{getDistrikt().text}} {{getDistrikt().guidelines}}</p>
               <button class="bg-black rounded-full text-2xl font-bold px-4 py-5 text-white mt-6 w-1/2 mx-auto" @click="startGame()"> Start Game </button>

                </div>

       <!--          <div class="distrikt_intro black">
                    <h1>{{game.title}}</h1>
                    <p v-if="game.scheduled" class="border-t py-4">{{getDate(game.scheduled)}}</p>
                    <a v-if="game.zoom" class="border-t py-4" :href="game.zoom" target="_blank">Video Call (Zoom)</a>
                    <h1>Players</h1>
                     <p class="border-t py-4" v-for="(item, index) in game.players" :key="index">
                <b>{{ getPlayer(item).name }}</b> -
                {{ getPlayer(item).email }}
            </p>
                </div> -->
                
            </div>
            <div v-if="game.index > -1" class="current_event"  :style="'background: url(' + currentEvent(game.rounds[game.index].event).image + ')'">
                <div class="game_info flex justify-between">
                    <div class="h-full flex items-center">
                        <span class="text-left text-white font-light text-2xl mr-2"  style="font-weight: 100 !important; font-family: 'EB Garamond', serif;">{{getDistrikt().name}}</span>
                        <span class="text-left border-l pl-3 text-white font-light text-xl ml-1" style="border-color: rgba(255,255,255,0.2)">
                          Round {{parseInt(game.rounds[game.index].index) + 1}}</span>
                    </div>
                        <div class="indicators flex items-stretch justify-center">
                            <div v-for="(item, key, index) in game.score" :key="index" style="border-color: rgba(255,255,255,0.1);"  class="flex w-auto items-center justify-center border-l py-3 font-light capitalize text-white text-lg text-center">
                               <div class="mx-auto"><span class="font-bold mr-0"> {{ item }} </span> {{ key }}</div>
                            </div>
                        </div>
                
                </div>
                <div class="event_view">
                <div class="event_information">
                <div class="event_image">
                    <img :src="currentEvent(game.rounds[game.index].event).image" />
                </div>
                <div class="px-4">
                    <h1 class="px-5 text-4xl" style="font-weight: 100 !important; font-family: 'EB Garamond', serif;">{{ this.currentEvent(game.rounds[game.index].event).name }}</h1>
                          <div class="flex mx-auto justify-center w-auto mb-3">
                        <p v-for="(item, key, index) in showIndicators()" :key="index" class="border capitalize mr-3 text-2xl font-bold p-3" style="border-color: rgba(255,255,255,0.8)">
                            {{ item }} {{ key }}
                        </p>
                    </div>
                    <p class="event_text">{{ this.currentEvent(game.rounds[game.index].event).text }}</p>
              
                    <div class="button play test" @click="playModal()">Play your card</div>
                </div>
            </div>
            </div>
                <modal name="play-modal" class="test_modal" height="800px" width="1400px" @closed="scoreBoard = false">
                    <div style="height: 100%; overflow: scroll;" v-if="!scoreBoard" class="modal_cards">
                        <div class="modal_header flex justify-between w-full">
                            <h2 class="text-3xl font-bold mb-6">Play Your Card</h2>
                             <div class="indicators text-black flex items-stretch justify-center">
                            <div v-for="(item, key, index) in game.score" :key="index" style="border-color: rgba(0,0,0,0.1);"  class="flex w-auto items-center justify-center border-l py-3 font-light capitalize px-3 text-2xl text-center">
                               <div class="mx-auto"><span class="font-bold mr-0"> {{ item }} </span> {{ key }}</div>
                            </div>
                        </div>
                        </div>
                         <masonry :cols="3" :gutter="5" class="table" style="padding-bottom: 100px; width: 100%;">
                            <Card v-for="(item, index) in getCards()" :key="index" :item="displayCard(item)" :playable="true" @played="sendEvent" :selectable="false" />
                        </masonry>
                        
                    </div>
                    <div v-if="scoreBoard" class="scoreBoard flex flex-col h-full justify-center">
                        <div style="width: 100%" class="flex flex-col bg-black">
                        <div class="active_card mb-4" :style="'background: url(' + displayCard(game.active).image + ')'">
                            <div class="description">
                                <h2 class="font-bold text-xl">{{displayCard(game.active).name}}</h2>
                                <p>{{displayCard(game.active).gameplay}}</p>
                            </div>
                        </div>
                        <div class="score">
                        <h4>Score Impact</h4>

                        <table class="tg">

                            <tbody>
                              <tr v-for="(item, key, index) in game.score" :key="index">
                                <td>{{key}}</td>
                                <td>
                                    <div class="scoreUpdate">
                                        <span class="icon minus" @click="changeScore(key, 'minus')"></span>
                                        <span class="number">{{ item }}</span>
                                        <span @click="changeScore(key, 'add')" class="icon plus"></span>
                                    </div>
                                </td>
                              </tr>
                            </tbody>
                        </table>
                    </div>
                        <button class="confirm" @click="confirmCard()">Confirm score</button>
                    </div>

               
                        <div style="width: 100%; background: white" class="p-10 gameplay_history">
                            <div style="width: 100%" class="text-left">
                            <h4>Game History</h4>
                            <p>Remember to check previously played cards before updating the score. <br />Regen cards apply each turn unless otherwise stated.</p>
                            </div>

                             <div class="history" style="height: 85%; overflow: scroll">
                                <table class="tg" >
                                    <thead>
                                      <tr>
                                        <td>Round</td>
                                        <td>Type</td>
                                        <td>Policy</td>

                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item, index) in showHistory()" :key="index" :class="{'regen': !displayCard(item.policy).single_use}" :content="displayCard(item.policy).gameplay" v-tippy="{followCursor : true}">
                                        <td>{{item.index}}</td>
                                        <td><span v-if="displayCard(item.policy).single_use">One Time</span><span v-else>Regenerative</span></td>
                                        <td>{{displayCard(item.policy).name}}</td>
                            
                                      </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </modal>
            </div>
            <!-- <p>{{ game.zoom }}</p> -->
            <!-- <p>{{ game.date }}</p> -->
            <!--       <div class="mt-10">
        <h1 class="text-left font-bold text-3xl mt-10 mb-4">Events Library</h1>
        <div class="w-full">
          <input type="text" class="w-full p-6" />
        </div>
        <div class="divTable">
          <div class="divTableBody">
            <div
              class="divTableRow"
              v-for="(item, index) in $store.events"
              :key="index"
              @click="updateGame(item.id)"
            >
              <div class="divTableCell">{{ item.name }}</div>
              <div class="divTableCell">{{ item.indicators }}</div>
            </div>
          </div>
        </div>
      </div> -->
        </div>
    </div>
    <div class="w-full h-full flex items-center justify-center loading" v-else>
        <div class="flex flex-col items-center justify-center">
        <h1>Loading</h1>
         <div class="circle circle2"></div>
     </div>
    </div>
</div>
</template>
<script>
import Card from "../components/Cards/Policy.vue";
import { SyncClient } from "twilio-sync";
export default {
    name: "User",
    data: () => ({
        select: "event",
        card: null,
        history: null,
        browserSupported: true,
        loading: true,
        ownId: "loading",
        peerId: "dwljikjk",
        msg: "welcome",
        game: null,
        connections: [],
        messages: [],
        scoreBoard: false,
        twilio: null,
        loaded: false
    }),
    components: {
        Card
    },
    methods: {
        getDate(timestamp) {
            var date = new Date(timestamp);
function addZeroBefore(n) {
  return (n < 10 ? '0' : '') + n;
}
var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

           return days[date.getDay()] + ' ' + date.getDate()+
          "/"+(date.getMonth()+1)+
          "/"+date.getFullYear()+ " at " +
          " "+addZeroBefore(date.getHours())+
          ":"+addZeroBefore(date.getMinutes())
        },
        startGame(){
            this.nextRound(this.game.id);
        },
        showIndicators(){
            var indicators = this.currentEvent(
               this.game.rounds[this.game.index].event
              ).indicators

            const removeZero = item => (
                Object
                .keys(item)
                .filter(key => item[key] !== 0)
                .reduce((newObj, key) => {
                    newObj[key] = item[key];
                    return newObj;
                    }, {})
                );
            const result = removeZero(indicators);
            return result;
        },
        confirmCard() {
            var obj = {
                database: this.game.id,
                row: this.game.rounds[this.game.index].id,
                card: this.game.active,
                round: this.game.index,
                score: this.game.score
            }
            var self = this;
            console.log(obj);
            fetch("/.netlify/functions/play", {
                    method: "Post",
                    body: JSON.stringify(obj),
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log(data);
                    self.$modal.hide("play-modal");
                    self.nextRound(self.game.id);
                })
                .catch(function(error) {
                    window.console.log(error);
                });

        },
        sendEvent(id) {
            this.scoreBoard = true;
            console.log('card' + id);
            this.game["active"] = id;
        },
        changeScore(key, type) {
            if (type == 'minus') {
                if (this.game.score[key] > 0) {
                    this.game.score[key] = this.game.score[key] - 1;
                }
            }
            if (type == 'add') {
                if (this.game.score[key] < 5) {
                    this.game.score[key] = this.game.score[key] + 1;
                }
            }
        },
        playModal() {
            this.$modal.show("play-modal");
            this.getHistory();
        },
        showHistory(){
            return this.game.history.filter(x => x.policy).reverse()
        },
        getToken: async function(identity) {
             var obj = {
                id: identity
            };

            const response = await fetch(`.netlify/functions/twilio`, {
                    method: "Post",
                    body: JSON.stringify(obj),
                })
            const responseJson = await response.json();
            return responseJson
        },
        createSyncClient(token) {
            var self = this;
            window.syncClient = SyncClient;
    this.syncClient = new SyncClient(token);

            this.syncClient.on('connectionStateChanged', function(state) {
                if (state === 'connected') {
                    self.client = state;
                    self.status = 'connected';
                } else {
                    self.status = 'error';
                    self.errorMessage = `Error: expected connected status but got ${state}`
                }
            });
            this.syncClient.on('tokenAboutToExpire', function() {
              console.log('about to expire')
            });
            this.syncClient.on('tokenExpired', function() {
              console.log('expired')
            });
          },
        syncState: async function() {
            const token = await this.getToken('owen-222');
            this.createSyncClient(token);
            var self = this;
            this.syncClient.document('MyDocument')
            .then(function(document) {
                // Listen to updates on the Document
                document.on('updated', function(event) {
                  console.log('Received Document update event. New data:', event.data);
                  self.twilio = event.data;
                });

                // Update the Document data
                var newData = { temperature: Math.floor(Math.random() * 10) };
                return document.set(newData);
              })
              .then(function(updateResult) {
                console.log('The Document was successfully updated', updateResult)
              })
              .catch(function(error) {
                console.error('Unexpected error', error)
              });
        },
        getTwilio() {
            var obj = {
                id: 'owen'
            };
            var self = this;

            fetch("/.netlify/functions/twilio", {
                    method: "Post",
                    body: JSON.stringify(obj),
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    self.twilio = data;
                })
                .catch(function(error) {
                    window.console.log(error);
                });
        },
        getHistory() {
            var obj = {
                id: this.game.id
            };
            var self = this;

            fetch("/.netlify/functions/history", {
                    method: "Post",
                    body: JSON.stringify(obj),
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    self.game["history"] = data.rounds
                })
                .catch(function(error) {
                    window.console.log(error);
                });
        },
        selectView(value, item) {
           
            if (value == "card") {
                this.card = item;
            }
            if (value == "history") {
                this.getHistory();
            }
             this.select = value;
        },
        selectGame(id) {
            this.game = this.$store.games.filter((x) => x.id == id)[0];
        },
        previousRound(id) {
            this.$store.games.find(item => item.id == id).index--
        },
        nextRound(id) {
            this.$store.games.find(item => item.id == id).index++;
            this.updateScore(id);
            var self = this;
            this.syncClient.document('MyDocument')
            .then(function(document) {
                // Listen to updates on the Document
                document.on('updated', function(event) {
                  console.log('Received Document update event. New data:', event.data);
                  self.twilio = event.data;
                });

                // Update the Document data
                var newData = { match: self.game.id, index: self.game.index, score: self.game.score };
                return document.set(newData);
              })
              .then(function(updateResult) {
                console.log('The Document was successfully updated', updateResult)
              })
              .catch(function(error) {
                console.error('Unexpected error', error)
              });
        },
        updateScore(id) {
            console.log(id);
            var event = this.currentEvent(
                this.game.rounds[this.game.index].event
            ).indicators;
            console.log(event);
            this.game.score.economy = this.game.score.economy + event.economy;
            this.game.score.opinion = this.game.score.opinion + event.opinion;
            this.game.score.infrastructure = this.game.score.infrastructure + event.infrastructure;
        },
        pingParticipants(id) {
            const newMessage = {
                event: id,
            };
            const conn = this.myPeer.connect(
                "f32226337b-b7e1-4e55-83d3-7958a73c9d0e"
            );

            conn.on("open", () => {
                conn.send(newMessage);
            });
        },
        updateGame(id) {
            this.pingParticipants(id);

            var obj = {
                event: id,
                game: this.game.id,
                id: "91d6aed73a984264ad9c1a5344c20ce5",
                type: "game",
            };

            fetch("/.netlify/functions/update", {
                    method: "Post",
                    body: JSON.stringify(obj),
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log(data);
                })
                .catch(function(error) {
                    window.console.log(error);
                });
        },
        fetchEvents() {
            var self = this;

            fetch("/.netlify/functions/events")
                .then(function(response) {
                    // handle success
                    return response.json();
                })
                .then(function(data) {
                    // `data` is the parsed version of the JSON returned from the above endpoint.
                    console.log(data); // { "userId": 1, "id": 1, "title": "...", "body": "..." }
                    self.$store.events = data.events;
                })
                .catch(function(error) {
                    // handle error
                    window.console.log(error);
                });
        },
        getPlayer(id) {
            return this.$store.players.filter((x) => x.id == id)[0];
        },
        getDistrikt() {
            var id = this.game.players[0];
            var distrikt_id = this.$store.players.filter((x) => x.id == id)[0].distrikt.id;
            return this.$store.distrikts.filter(x => x.id == distrikt_id)[0];
        },
        currentEvent(id) {
            return this.$store.events.filter((el) => {
                return el.id == id;
            })[0];
        },
        fetchDistrikts() {
      var self = this;
      fetch("/.netlify/functions/distrikts")
        .then(function(response) {
          // handle success
          return response.json();
        })
        .then(function(data) {
          // `data` is the parsed version of the JSON returned from the above endpoint.
          console.log(data); // { "userId": 1, "id": 1, "title": "...", "body": "..." }
          self.$store.distrikts = data.distrikts;
        })
        .catch(function(error) {
          // handle error
          window.console.log(error);
        });
    },
        getCards(filtered) {
            var self = this;
            let cards = this.game.players.map(function(id) {
                let filteredCards = self.$store.players.filter(function(x) {
                    return x.id == id;
                });
                return filteredCards[0].policies
            })

            function sortByFrequency(array) {
                var frequency = {};

                array.forEach(function(value) { frequency[value] = 0; });

                var uniques = array.filter(function(value) {
                    return ++frequency[value] == 1;
                });

                return uniques.sort(function(a, b) {
                    return frequency[b] - frequency[a];
                });
            }

            var sorted = sortByFrequency(cards.flat());

            if (filtered == true ) {
                var regen = sorted.filter(x => this.displayCard(x).single_use == false).slice(0,2);
                var single = sorted.filter(x => this.displayCard(x).single_use == true).slice(0,3);
                return regen.concat(single);
            } else {
                return sorted
            }


        },
        fetchGames() {
            var self = this;

            fetch("/.netlify/functions/matches", {
                    method: "Post"
                })
                .then(function(response) {
                    // handle success
                    return response.json();
                })
                .then(function(data) {
                    // `data` is the parsed version of the JSON returned from the above endpoint.
                    console.log(data); // { "userId": 1, "id": 1, "title": "...", "body": "..." }
                    self.$store.games = data.notion;
                    self.game = data.notion[0];
                })
                .catch(function(error) {
                    // handle error
                    window.console.log(error);
                });
        },
        fetchPlayers() {
            var self = this;

            fetch("/.netlify/functions/players", {
                    method: "Post"
                })
                .then(function(response) {
                    // handle success
                    return response.json();
                })
                .then(function(data) {
                    // `data` is the parsed version of the JSON returned from the above endpoint.
                    console.log(data); // { "userId": 1, "id": 1, "title": "...", "body": "..." }
                    self.$store.players = data.notion;
                })
                .catch(function(error) {
                    // handle error
                    window.console.log(error);
                });
        },
        setListeners(conn) {
            conn.on("data", (data) => {
                console.log(data);
            });

            conn.on("close", () => {
                this.connections = this.connections.filter(
                    (connection) => connection.connectionId !== conn.connectionId
                );
            });

            conn.on("error", (err) => {
                console.error(err);
            });
        },
        connect: function() {
            const conn = this.$peer.connect(this.peerId, {
                label: "user",
                metadata: {
                    name: "userName",
                },
                serialization: "json",
            });

            conn.on("open", () => {
                conn.send("hi!");
                this.connections.push(conn);
                this.setListeners(conn);
            });
        },
        poke: function(conn) {
            conn.send("poke!");
        },
        displayCard(id) {
            return this.$store.cards.filter(x => x.id == id)[0]
        },
    },
    computed: {},
    mounted() {
        this.syncState();
    },
    created() {
        setTimeout(() => this.loaded = true, 3000);
        this.fetchDistrikts();
        this.fetchEvents();
        this.fetchGames();
        this.fetchPlayers();

    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.loading {
    @apply flex justify-center items-center;
    h1 {
         @apply text-4xl font-light mb-6;
             font-family: "EB Garamond", serif;
    }
}
.circle {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  animation: rotate 2.5s linear infinite;
}

/* ==== Animation 1 ====  */
.circle1 {
  box-shadow: 0px 5px 5px 3px #0496ff, 0px -5px 5px 3px #ff0000,
    -5px 0px 5px 3px #a1ff0a, 5px 0px 5px 3px #f8ffe5;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

/* ==== Animation 2 ====  */
.circle2 {
  box-shadow: 0px 5px 5px 3px #0496ff;
}
.round_introduction {
    @apply h-full flex items-stretch justify-center;
    background-size: cover !important;
    background-position: 50% 50% !important;
    .distrikt_intro {
        @apply flex flex-col px-40 mx-auto;
        background: rgba(255,255,255,0.4);
        backdrop-filter: blur(29px);
        color: black;
        padding:5% 20%;
        img.distrikt {
            @apply border p-2 mb-8 mx-auto;
        max-height: 800px;
            background: rgba(0,0,0,0.1);
            border-color: rgba(255,255,255,0.4);
        }
        h1 {
            @apply text-4xl font-bold border-b mb-3 pb-2;
            border-color: rgba(0,0,0,0.09);
        }
        p, a {
            @apply text-2xl font-light;
             font-family: "EB Garamond", serif;
        }
        &.black {
            @apply py-5 pb-2;
            background: rgba(0,0,0,0.4);
            color: white;
            width: 40% !important;
            flex-shrink: 0;
            h1 {
                @apply text-2xl font-bold my-4 pb-0;
                border: none;
            }
            p, a {
                border-color: rgba(255,255,255,0.1);
            }
            a {
                @apply italic;
                &:hover {
                    @apply underline
                }
            }
        }
    }

}
.scoreBoard {
    @apply flex flex-row items-center justify-center;
    align-items: stretch;
    .scoreUpdate {

        @apply flex overflow-hidden w-full items-center flex;
        .number {
            @apply h-full flex items-center px-4 font-bold;
              height: 40px;
        }
       
    }
    .active_card {
        background-size: cover !important;
        background-position: 50% -60px !important;
        height: 350px;
        background-color: black;
        @apply flex flex-col justify-end;
        h2 {
            text-decoration: none;
            border-color: rgba(255,255,255,0.2);
            @apply text-4xl mx-auto border-b pb-2 mb-3;
            width: 70%;
        }
        .description {
            background: linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
            height: 90%;
            @apply flex flex-col justify-end ;
            color: white !important;

            p {
                @apply px-10 pb-4 leading-tight text-2xl;
                color: white !important;
            }
        }
        img {
            height: 200px;
            object-fit: cover;
            width: 100%;
        }
    }
    button.confirm {
        background: rgba(255,255,255,0.2);
        color: white;
        @apply font-bold text-xl rounded-full px-6 mt-6 py-4 inline-flex w-auto mx-auto;
        &:hover {
            background: rgba(255,255,255,0.3);
        }
    }
    p {
        color: black;
        text-shadow: none;
    }

    .icon {
        width: 30px;
        height: 30px;
        @apply relative rounded-full flex;
        color: white;
        background-color: rgba(255,255,255,0.2) !important;

        &:hover {
            cursor: pointer;
            background-color: rgba(255,255,255,0.3) !important;
        }

        &.minus {
            background: url("data:image/svg+xml,%3Csvg width='72' height='19' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M45.4.2h21.8c2.4 0 4.4 2 4.4 4.3v10c0 2.5-2 4.5-4.4 4.5H4.8c-2.4 0-4.4-2-4.4-4.4v-10C.4 2 2.4.1 4.8.1h40.6Z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E") no-repeat center center;
            background-size: 8px;
        }

        &.plus {
            background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' xml:space='preserve'%3E%3Cpath fill='%23fff' fill-rule='evenodd' clip-rule='evenodd' d='M45 14.4h10c2.4 0 4.4 2 4.4 4.4v21.8h21.8c2.4 0 4.4 2 4.4 4.4v10c0 2.4-2 4.4-4.4 4.4H59.4v21.8c0 2.4-2 4.4-4.4 4.4H45c-2.4 0-4.4-2-4.4-4.4V59.4H18.8c-2.4 0-4.4-2-4.4-4.4V45c0-2.4 2-4.4 4.4-4.4h21.8V18.8c0-2.4 2-4.4 4.4-4.4z'/%3E%3C/svg%3E") no-repeat center 60%;
            background-size: 12px;
        }
    }
}

.tg  {border-collapse:collapse;border-spacing:0; @apply mx-auto; width: 100%}
.tg td{border-color:black;border-style:solid;border:1px solid #efefef;font-family:Arial, sans-serif;font-size:14px;
  overflow:hidden;padding:10px 5px;word-break:normal;}
.tg thead tr {
    background: #fafafa;
    @apply font-bold;
}


.tg td {
        padding: 15px 20px !important;


}

.score {
    width: 60% !important;
    @apply font-bold mx-auto border;
    border-color: rgba(255,255,255,0.14);
    color: white;
    h4 {
        font-family: 'EB Garamond', serif; 
       @apply  w-full text-center text-3xl w-full py-4 text-center mx-auto text-white font-light;
       background: rgba(255,255,255,0.07);
    }
    td {
        background: black;
        padding: 10px 0 !important;
        border:none;
        @apply text-xl;
    }
    tr {
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        td:first-child {
            padding: 10px 40px !important;
            text-transform: capitalize;
        }
        &:last-child {
            border: none
        }
    }
}

div /deep/ .vm--modal {
    background: rgba(255,255,255,0.8) !important;
    backdrop-filter: blur(10px);
}

.modal_cards {
    @apply  w-full flex flex-col justify-center items-center overflow-scroll;
    padding-top: 130px;
    padding-bottom: 100px !important;
    .table {
        @apply inline-block h-full w-full;
    padding-bottom: 100px !important;
     margin-bottom: 100px !important;
max-width: 1300px;
    }
    .modal_header {
        @apply absolute w-full flex items-center justify-between px-10;
        position: absolute;
        top: 0;
        height: 80px;
        background: rgba(0,0,0,0.02);
        color: black;
        backdrop-filter: blur(10px);
        z-index: 999;
        h2 {
            @apply text-2xl;
            text-decoration: none;
            margin: 0;
            padding: 0;
        }
    }

}
.gameplay_history {
    h4 {
        @apply text-4xl border-b pb-2 mb-3;
           font-family: "EB Garamond", serif;
        font-weight: light !important;
    }
    p {
 @apply leading-tight text-2xl mb-4;
 color: rgba(0,0,0,0.8);
                   font-family: "EB Garamond", serif;
    }
}
.history {
            tr:hover {
            cursor: pointer;
            background: rgba(0,0,0,0.02);
        }
}

.tg tr.regen {
    background-color: rgba(204, 255, 204, 0.6) !important;
    font-weight: bold;
&:hover {
     background-color: rgba(204, 255, 204, 0.8) !important;
}
}


.current_event {
    @apply relative flex items-center mx-auto;
            height: 100vh;
background-size: cover !important;
background-position: 50% 50% !important;
    width: 100%;
    overflow: hidden;

    .game_info {
        position: absolute;
        top: 0;
        width: 100%;
        @apply pl-8 pr-2 flex items-center justify-between;
        height: 60px;
        z-index: 2;
        background: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(10px);
        .indicators {
            width: auto;
            @apply flex;
            div {
                @apply px-2;
            }
          
        }

        h1 {
            margin: 0
        }
    }

    .event_image {
        width: 45%;
        flex-shrink: 0;
        height: auto;

        @apply flex mr-6 items-center justify-center;
        img {
            width: 100%;
            min-height: 400px;
            height: auto;
            object-fit: cover;
             @apply border p-2;
            background: rgba(0,0,0,0.1);
            border-color: rgba(255,255,255,0.06);
        }
    }

    .event_view {
        @apply flex justify-center items-center;
        background: rgba(0,0,0,0.7);
        backdrop-filter: blur(10px);
        width: 100%;
        height: 100%;
    }

    .event_information {
        height: auto;
        @apply flex justify-center items-center;
        color: white;
        width: 90%;
        flex-shrink: 0;
        z-index: 0;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    h1 {
        color: white;
        @apply text-6xl border-b mb-3 pb-2 font-bold;
border-color: rgba(255,255,255,0.3);
        text-shadow: 0 2px 2px rgba(0, 0, 0, 0.8);
    }

    p.event_text {
        color: white;
        @apply text-3xl px-10 mb-4;
        text-shadow: 0 2px 2px rgba(0, 0, 0, 0.8);
    }
}

h3 {
    text-decoration: underline;
}

.highlight {
    background: white;
    @apply p-8 mb-6 border mx-auto;
    width: 80%;
    max-width: 600px;

    h1.title {
        @apply text-3xl mt-0 mb-0;
    }
}

h2 {
    text-decoration: underline;
    @apply px-3;
}

.hooper:focus {
    outline: none;
}

.text {
    text-align: left;
    width: 65%;
    margin: 0 auto;
}

.select {
    @apply py-4 px-3 border-b my-0;
    transition: all 0.1s ease;

    span {
        @apply text-lg w-full inline-block pb-0 mt-0 pt-0;
        font-weight: normal;
    }

    ul.collapse {
        max-height: 0px;
        overflow: hidden;
        @apply pl-2;
        transition: max-height .3s ease;

        li {
            @apply border-b py-3 px-0;
            &.active {
                @apply font-bold;
            }

            &:last-child {
                border: none;
                @apply pb-0;
            }
        }
    }

    &:hover {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.01);
    }

    &.active {
        span {
            font-weight: 600;
        }

        .collapse {
            max-height: 300px;
       
        }
    }
}

.welcome {
    width: 80%;
    @apply mx-auto px-2 border-b;
}

.hooper {
    width: 100%;
}

.cards_row {
    @apply p-20;
    width: 100%;
    margin: 0 auto;
    background: #fff;
}

.distrikt {
    .card_large {
        .card_header.has_image {
            height: 500px;
            background-position: 50% 50% !important;

            .card_info {
                h3 {
                    @apply mb-5;
                }

                p {
                    @apply text-lg leading-normal;
                }
            }
        }
    }
}

.card_large {
    @apply shadow-lg bg-white p-7 border;

    p {
        width: 75%;
    }

    .card_play {
        padding-left: 40px;
        @apply font-normal text-left pl-16 leading-tight pr-4 py-4 border-t border-b;
        width: 50%;
        margin: 20px auto 0;
    }

    .regen {
        background: url("data:image/svg+xml,%3Csvg width='68' height='96' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M59.7.5c4.2 0 7.6 3.4 7.6 7.7v79.7c0 4.3-3.5 7.7-7.7 7.7H8.3a7.7 7.7 0 0 1-7.7-7.7V8.2C.6 3.9 4.1.5 8.3.5Zm-26.1 31a16 16 0 1 0 0 32 16 16 0 0 0 0-32Zm.03 3.15c.33-.28.84-.03.84.4v2.88c5.1.38 9.24 4.54 9.54 9.64a10.34 10.34 0 0 1-20.63 1.32.62.62 0 0 1 .63-.69h2.35c.33 0 .6.26.63.59a6.74 6.74 0 0 0 13.38.17 6.73 6.73 0 0 0-5.9-7.42v2.78c0 .43-.5.68-.84.4l-5.85-4.62a.53.53 0 0 1 0-.8Z' fill='green' fill-rule='nonzero'/%3E%3C/svg%3E") no-repeat 24px center #fafafa;
        background-size: 25px;
    }

    .single_use {
        background: url("data:image/svg+xml,%3Csvg width='68' height='96' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M59.7.5c4.2 0 7.6 3.4 7.6 7.7v79.7c0 4.3-3.5 7.7-7.7 7.7H8.3a7.7 7.7 0 0 1-7.7-7.7V8.2C.6 3.9 4.1.5 8.3.5Zm-26.1 31a16 16 0 1 0 0 32 16 16 0 0 0 0-32Zm.1 8.5 1 .1c.1.1.3.3.3.5l.1 1V47l.1 6.4h2.7v.1l.2.7c0 .3-.1.4-.2.5l-.6.2H29v-.2l-.2-.7c0-.2 0-.4.2-.5l.5-.1h2l.1-.1V45.1a24.3 24.3 0 0 0-.2-2.3c0-.2-.2-.3-.4-.4h-2v-.2l-.2-.6c0-.5.7-1 2-1.2 1.3-.3 2.2-.4 2.8-.4Z' fill='orangered' fill-rule='nonzero'/%3E%3C/svg%3E") no-repeat 24px center #fafafa;
        background-size: 25px;
    }

    .quote {
        width: 75%;
        @apply mx-auto text-xl pb-6 border-b mt-8;
        font-family: "EB Garamond", serif;
        font-weight: light;
    }

    .gameplay {
        @apply text-xl pt-5 mx-auto;
        font-family: "EB Garamond", serif;
        font-weight: light;
    }

    .card_header {
        width: 100%;
        height: auto;
        @apply flex items-end bg-cover rounded;
        background-position: 10% 100% !important;
        background-color: #fafafa !important;
        background-size: cover !important;
        background-repeat: no-repeat !important;

        p {
            font-family: "EB Garamond", serif;
        }

        .card_info {
            width: 80%;
            height: 100%;
            @apply py-8 pl-10 pr-0 mx-auto text-center;
            text-decoration: none;
            color: black;
            font-family: "EB Garamond", serif;
            backdrop-filter: blur(10px);

            h3 {
                @apply text-3xl mb-2 border-b pb-3;
                text-decoration: none;
            }

            p {
                @apply pr-0 w-full text-xl;
            }
        }

        &.has_image {
            .card_info {
                @apply text-left;
                width: 40%;
                margin: inherit;
                color: white;
                background: linear-gradient(180deg,
                    rgba(0, 0, 0, 1) 0%,
                    rgba(0, 0, 0, 0) 100%);

                h3 {
                    @apply mr-10;
                }

                p {
                    @apply pr-8 text-base;
                }
            }
        }
    }
}

.sidebar {
    @apply bg-gray-100 pt-4;
    width: 400px;
}

h1.title {
    font-family: "EB Garamond", serif;
    text-shadow: 0px -1px 0px white;
    width: 80%;
    @apply text-5xl mt-4 mb-4 mx-auto pb-4 border-gray-200;
}

.link {
    &:hover {
        cursor: pointer;
    }
}

/* DivTable.com */
.divTable {
    display: table;
    width: 100%;
    @apply mx-auto;
}

.divTableRow {
    display: table-row;
}

.divTableRow:hover {
    cursor: pointer;
    background: #efefef;
}

.divTableHeading {
    background-color: #fff;
    display: table-header-group;
}

.divTableCell,
.divTableHead {
    border: 0.5px solid #ddd;
    display: table-cell;
    padding: 15px 20px;
    text-align: left;
}

.divTableHeading {
    background-color: #eee;
    display: table-header-group;
    font-weight: bold;
}

.divTableFoot {
    background-color: #eee;
    display: table-footer-group;
    font-weight: bold;
}

.divTableBody {
    display: table-row-group;
}

.button {
    @apply px-6 py-4 shadow-lg inline-flex relative text-2xl mt-3 font-bold text-center rounded-full;
    text-decoration: none;
    z-index: 9;

    &.play {
        color: black;
        background: rgba(255,255,255,0.8);
    }
}
</style>